export default "__VITE_ASSET__C7UeY2ie__"